import Templates from "../components/Templates";

const TemplatesScreen = () => {
  return <Templates />;
};
export default TemplatesScreen;
